// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","logoHolder":"header_logoHolder__YnSet","searchFormHolder":"header_searchFormHolder__9thGn","prcInfoIcon":"header_prcInfoIcon__+hjaH"};